import DocumentsStore from "stores/documentsStore";
import { DocumentType } from "thunk-core";

export default class NotesStore extends DocumentsStore {
  constructor() {
    super(DocumentType.NOTE);
  }
}
